import { Star } from "lucide-react";
import {
  PlayHero,
  KeyFactorsGrid,
  MartingalePlanBlock,
  DkMoneylineRow,
  DkCtaButton,
} from "./play/PlayCardParts";

const SPORT_HERO = {
  mlb: "https://images.pexels.com/photos/269948/pexels-photo-269948.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  nba: "https://images.unsplash.com/photo-1612563974815-4c45b555e04c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxiYXNrZXRiYWxsJTIwaG9vcCUyMGRhcmt8ZW58MHx8fHwxNzc2NDQ4OTI2fDA&ixlib=rb-4.1.0&q=85",
  nhl: "https://images.unsplash.com/photo-1678213967566-6d9d1d78a5ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxob2NrZXklMjBwbGF5ZXIlMjBpY2UlMjBkYXJrJTIwbW9vZHl8ZW58MHx8fHwxNzc2NDQ4OTE0fDA&ixlib=rb-4.1.0&q=85",
  mma: "https://images.unsplash.com/photo-1620123449946-30d6efd4b8ba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxtbWElMjBmaWdodGVyJTIwYm94aW5nJTIwcmluZyUyMGRhcmt8ZW58MHx8fHwxNzc2NDQ4OTE0fDA&ixlib=rb-4.1.0&q=85",
};

const DRAFTKINGS_AFFILIATE_URL = "https://www.draftkings.com/r/mabecks/US-DK/-";

function Stars({ n }) {
  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={12}
          strokeWidth={1.5}
          className={i <= n ? "fill-[#00D4FF] text-[#00D4FF]" : "text-zinc-700"}
        />
      ))}
    </div>
  );
}

function PickRow({ card, a }) {
  return (
    <div className="flex items-baseline justify-between gap-3">
      <div>
        <div className="overline">THE PICK</div>
        <div
          className="font-display text-2xl neon-text"
          data-testid={`pick-${card.game_id}`}
        >
          {a.pick || "Pass"}
        </div>
      </div>
      {card.market?.details && (
        <div className="text-right">
          <div className="overline">MARKET</div>
          <div className="mono text-sm">{card.market.details}</div>
          {card.market.over_under && (
            <div className="mono text-xs text-zinc-500">O/U {card.market.over_under}</div>
          )}
        </div>
      )}
    </div>
  );
}

export default function PlayCard({ card }) {
  const a = card.analysis || {};
  const kf = a.key_factors || {};
  const mp = a.martingale_plan || {};
  const hero = SPORT_HERO[card.sport] || SPORT_HERO.mlb;
  const sportLabel = card.sport?.toUpperCase() || "";
  const signal = (a.sharp_signal || "").toUpperCase();
  const dkMoneyline = (card.dk_market && card.dk_market.moneyline) || [];

  return (
    <article
      className="border border-zinc-800 bg-zinc-950/60 hover:border-[#00D4FF]/60 transition-colors"
      data-testid={`play-card-${card.game_id}`}
    >
      <PlayHero
        card={card}
        hero={hero}
        sportLabel={sportLabel}
        signal={signal}
        Stars={Stars}
        confidence={a.confidence || 0}
      />
      <div className="p-5 space-y-4">
        <PickRow card={card} a={a} />
        <p className="text-sm text-zinc-400 leading-relaxed">{a.rationale}</p>
        <KeyFactorsGrid kf={kf} />
        <MartingalePlanBlock mp={mp} />
        {a.risk_note && (
          <div className="flex gap-2 text-xs text-amber-400">
            <span>⚠</span>
            <span className="leading-relaxed">{a.risk_note}</span>
          </div>
        )}
        <DkMoneylineRow dkMoneyline={dkMoneyline} />
        <DkCtaButton url={DRAFTKINGS_AFFILIATE_URL} gameId={card.game_id} />
      </div>
    </article>
  );
}
